import { serverURL } from '../config';

async function fetchToolData(req, sender) {
  const url = req.payload.url;
  let encodedUrl;
  if (decodeURI(url) === url) {
    // not already encoded
    encodedUrl = encodeURI(url);
  } else {
    // already encoded
    encodedUrl = url;
  }
  const toolDataRes = await fetch(`${serverURL}/api/tool?url=${encodedUrl}`);
  if (!toolDataRes.ok) {
    return {
      ok: toolDataRes.ok,
      status: toolDataRes.status,
    };
  }
  // todo does this fail if toolDataRes is not ok?
  const toolData = await toolDataRes.json();
  return {
    ok: toolDataRes.ok,
    status: toolDataRes.status,
    data: toolData,
  };
}

async function updateTool(req, sender) {
  const updateToolRes = await fetch(`${serverURL}/api/tool`, {
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(req.payload),
  });
  const updateToolData = updateToolRes.json();
  return updateToolData;
}

async function createDoc(req, sender) {
  const createDocRes = await fetch(`${serverURL}/api/doc`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(req.payload),
  });
  const createDocData = createDocRes.json();
  return createDocData;
}

async function updateDoc(req, sender) {
  const updateDocRes = await fetch(`${serverURL}/api/doc`, {
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(req.payload),
  });
  const updateDocData = updateDocRes.json();
  return updateDocData;
}

async function deleteDoc(req, sender) {
  const deleteDocRes = await fetch(`${serverURL}/api/doc`, {
    method: 'DELETE',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(req.payload),
  });
  const deleteDocData = deleteDocRes.json();
  return deleteDocData;
}

async function checkToolExists(req, sender) {
  const url = req.payload.url;
  let encodedUrl;
  if (decodeURI(url) === url) {
    // not already encoded
    encodedUrl = encodeURI(url);
  } else {
    // already encoded
    encodedUrl = url;
  }
  const checkToolExistsRes = await fetch(
    `${serverURL}/api/checkToolExists?url=${encodedUrl}`
  );

  return {
    ok: checkToolExistsRes.ok,
    status: checkToolExistsRes.status,
  };
}

export { fetchToolData, createDoc, updateDoc, deleteDoc, checkToolExists, updateTool };
